import type { EmbeddedPromptOut } from '@repo/api-codegen';
import { IconButton } from '@repo/foundations';
import { useAIFeedback, type IEmbeddedPrompt } from '../../../api';
import { SentimentType } from '../../../components/AIAssistant/AIFeedbackModal/constants';

export function PositiveFeedbackButton({
	message,
}: {
	message: IEmbeddedPrompt | EmbeddedPromptOut;
}) {
	const { showPositiveFeedbackModal } = useAIFeedback();

	if (message.user_feedback_raw?.sentiment === SentimentType.Positive) {
		return (
			<IconButton
				iconName="thumbUpFilled"
				variant="tertiary"
				tooltip="Positive feedback for this prompt already submitted"
			/>
		);
	}

	return (
		<IconButton
			iconName="thumbUp"
			variant="tertiary"
			onClick={() => showPositiveFeedbackModal(message.id)}
			tooltip="Helpful"
		/>
	);
}
